// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map_root__lk740 {
  min-height: 600px;
  flex: 1 1;
  gap: 8px;
}

.map_root__lk740 .mapboxgl-map {
  border-radius: 8px;
  flex: 1 1;
}

.map_leftCardsContainer__Wm6ww {
  width: 320px;
  height: 600px;
  overflow: scroll;
  padding-right: 16px;
}

.map_popup__NjPtL {
  width: 190px;
}`, "",{"version":3,"sources":["webpack://./src/components/manage-restaurants/list/map/map.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,SAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".root {\n  min-height: 600px;\n  flex: 1;\n  gap: 8px;\n}\n\n.root :global .mapboxgl-map {\n  border-radius: 8px;\n  flex: 1;\n}\n\n.leftCardsContainer {\n  width: 320px;\n  height: 600px;\n  overflow: scroll;\n  padding-right: 16px;\n}\n\n.popup {\n  width: 190px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `map_root__lk740`,
	"leftCardsContainer": `map_leftCardsContainer__Wm6ww`,
	"popup": `map_popup__NjPtL`
};
export default ___CSS_LOADER_EXPORT___;
